import { apiRequest } from '../../apiCall'


export const getPackageById = (params, userId) => apiRequest('Package.GetPackagesByUserId',
  { ...params },)


export const postActivePackage = (params) => apiRequest('Package.AddPackageForUser', { ...params }, "?Currency=" + params.Currency)
export const postUpdatePackage = (params) => apiRequest('Package.UpdatePackageForUser', { ...params },
  "?Currency=" + params.Currency)

export const getAvailablePackageList = (params) => apiRequest('Package.GetPackagesType', { ...params }, "?Currency=" + params.currency)

export const getInvoiceDetail = (params) => apiRequest('WhmcsProduct.InvoiceDetail', {}, "?invoiceId=" + params)
export const getUserInvoices = (params) => apiRequest('WhmcsProduct.GetUserInvoices', {})

export const getPackageByPackageId = (id) => apiRequest('Package.GetPackagesTypeById', {}, "?id=" + id)

export const getUpgradablePackagesRequest = (params) => apiRequest('Package.GetUpgradablePackages', {}, `?userId=${params.userId}&Currency=${params.currency}`)
export const getPackageServiceIdRequest = (params) => apiRequest('Package.GetPackageServiceId', {}, `?userId=${params.userId}`)
export const getClientProductRequest = (params) => apiRequest('Package.GetClientProduct', {}, `?userId=${params.userId}`)
export const upgradePackageRequest = (params) => apiRequest('APIRunner.TestApiRunner', { ...params })





